/**
 * mapOrientationControl.ts
 * 地図の回転・ピッチ・地形リセット関連メソッド
 * App.vue から切り出し
 */

import store from '@/store'
import { startHoldRotate, startHoldPitch } from '@/js/utils/view-orientation-anim'

type VM = any

export function targets(vm: VM, mapName: string, syncBoth: boolean) {
  const m1 = store.state.map01
  const m2 = store.state.map02
  const active = (store.state as Record<string, any>)[mapName]
  return syncBoth ? [m1, m2] : [active]
}
export function hillshadeStop(vm: VM) {
  // まず現在の陰影の状況を覚える
  vm.currentHillshadeMaps.map01 = vm.$store.state.hillshade.maps.map01
  vm.currentHillshadeMaps.map02 = vm.$store.state.hillshade.maps.map02
  // 次に陰影を中止
  vm.$store.commit('SET_HS_FOR', { mapKey: 'map01', enabled: false })
  vm.$store.commit('SET_HS_FOR', { mapKey: 'map02', enabled: false })
}
// --- 回転（押している間）---
export function pressRotateRight(vm: VM, mapName: string, { speed = 150, syncBoth = false } = {}) {
  hillshadeStop(vm)
  const tgts = targets(vm, mapName, syncBoth)
  vm.stopSpin?.()
  vm.stopSpin = startHoldRotate(tgts[0], { direction: +1, speed, targets: tgts })
}
export function pressRotateLeft(vm: VM, mapName: string, { speed = 150, syncBoth = false } = {}) {
  hillshadeStop(vm)
  const tgts = targets(vm, mapName, syncBoth)
  vm.stopSpin?.()
  vm.stopSpin = startHoldRotate(tgts[0], { direction: -1, speed, targets: tgts })
}
// --- ピッチ（押している間）---
export function pressPitchUp(vm: VM, mapName: string, { speed = 100, syncBoth = false } = {}) {
  hillshadeStop(vm)
  const tgts = targets(vm, mapName, syncBoth)
  vm.stopPitch?.()
  vm.stopPitch = startHoldPitch(tgts[0], { direction: +1, speed, targets: tgts })
}
export function pressPitchDown(vm: VM, mapName: string, { speed = 100, syncBoth = false } = {}) {
  hillshadeStop(vm)
  const tgts = targets(vm, mapName, syncBoth)
  vm.stopPitch?.()
  vm.stopPitch = startHoldPitch(tgts[0], { direction: -1, speed, targets: tgts })
}
// --- 離したら停止（mouseup / touchend などで呼ぶ）---
export function releaseOrientationButtons(vm: VM) {
  vm.stopSpin?.(); vm.stopSpin = null
  vm.stopPitch?.(); vm.stopPitch = null
  // 陰影を復活
  vm.$store.commit('SET_HS_FOR', { mapKey: 'map01', enabled: vm.currentHillshadeMaps.map01 })
  vm.$store.commit('SET_HS_FOR', { mapKey: 'map02', enabled: vm.currentHillshadeMaps.map02 })
  // パーマリンク更新
  vm.$store.commit('toggleUpdatePermalinkFire')
}
// --- リセット---
export function terrainReset(vm: VM, mapName: string) {
  hillshadeStop(vm)
  vm.map01.setTerrain(null)
  vm.map02.setTerrain(null)
  vm.$store.commit('setIsTerrainEnabled', false)
  vm.map01.easeTo({ bearing: 0, pitch: 0, duration: 600 })
  vm.map02.easeTo({ bearing: 0, pitch: 0, duration: 600 })
  setTimeout(() => {
    // 陰影を復活
    vm.$store.commit('SET_HS_FOR', { mapKey: 'map01', enabled: vm.currentHillshadeMaps.map01 })
    vm.$store.commit('SET_HS_FOR', { mapKey: 'map02', enabled: vm.currentHillshadeMaps.map02 })
    // パーマリンク更新
    vm.$store.commit('toggleUpdatePermalinkFire')
  },600)
}